// components/CurrentInvestmentForm.js
import React, { useState, useEffect } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { formatInWords } from '../utils/formatInWords';


import { useAppContext } from '../context/AppContext';

function CurrentInvestmentForm() {

  const { state, actions } = useAppContext();

  const [value, setValue] = useState({
    netWorth: state.netWorth || '',
  })

  useEffect(() => {
    setValue(
      {
        netWorth: state.netWorth,
      }
    )
  }, [state.netWorth])

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const handleChange = (field) => (e) => {
    let value = parseInt(e.target.value.replace(/,/g, ''), 10);
    if (isNaN(value)) value = 0;
    // onChange('currentInvestment', value);
    setValue((prev) => ({...prev, [field]: value}));
    actions.updateFormData(field, value);
  };

  // Format number with commas
  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-IN').format(num);
  };

  const handleInfoDialogOpen = () => {
    setInfoDialogOpen(true);
};

const handleInfoDialogClose = () => {
    setInfoDialogOpen(false);
};

  return (
    <Box>
      <CardContent>
        <Typography variant="h6" component="h2" sx={{fontWeight:"bold"}}>
          How secured is your financial future? Let's find out.
        </Typography>
        <br></br><br></br>
        <Typography variant="body1" component="h2" gutterBottom>
         What is your total financial net worth?
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        // startIcon={<InfoIcon />}
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={handleInfoDialogOpen}
                        sx={{ textTransform: 'none', fontSize: '0.875rem', mt:2}}
                    >
                        How to Compute Your Net Worth?
                    </Button>
                </Box>
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <TextField
            label="Your Financial Net Worth"
            value={value.netWorth ? formatNumber(value.netWorth) : ''}
            onChange={handleChange('netWorth')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
            // helperText="Include all investment accounts, retirement accounts, etc."
          />
        </Box>
        {value.netWorth >= 1000 && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          {formatInWords(value.netWorth)}
        </Typography>
)}

      </CardContent>

      <Dialog
        open={infoDialogOpen}
        onClose={handleInfoDialogClose}
        aria-labelledby="info-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
      <Typography variant="body2" color="textSecondary">
        Consider all financial investments (FDs, PPF, NPS, ULIPS, Bonds, Indian Stocks, International Stocks, Mutual Funds, PMS, AIF, etc). 
        <br></br><br></br>
        Exclude consumption assets (residential house, cars and personal jewellery etc).
        <br></br><br></br>
        Reduce outstanding loans and liabilities (home, auto, personal, cards, etc).
      </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleInfoDialogClose} variant="contained">
            Got it
        </Button>
      </DialogActions>
      </Dialog>
</Box>
  );

}

export default CurrentInvestmentForm;